<div class="estatisticas-cadastro">
    <app-painel-lateral
        [tituloPainel]="obterAgrupadorSelecionado().label"
        [descricaoPainel]="obterAgrupadorSelecionado().descricao"
        [iconePainel]="obterAgrupadorSelecionado().icon"
        [filtrosTemplate]="filtros"
        [conteudoTemplate]="conteudo"
        [ocultarFiltros]="!!estatisticaSelecionada"
    >
        <ng-template #filtros>
            <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF do estado</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
            </label>

            <label class="ano-filtro" for="estatisticas-prestador-ano">
                <span class="mapa-filtro-label">Ano</span>
                <input id="estatisticas-prestador-ano" class="ano-input p-inputtext" type="number" min="1900" [max]="anoAtual + 1" [(ngModel)]="anoSelecionado" />
            </label>

            <p-button icon="pi pi-refresh" label="Atualizar" type="button" (onClick)="aplicarFiltros()"></p-button>
        </ng-template>

        <ng-template #conteudo>
            @if (estatisticaSelecionada) {
                <app-detalhamento-pendencias
                    [indicador]="obterIndicadorAnalitico()"
                    [linhas]="linhasAnalitico"
                    [first]="firstAnalitico"
                    [rows]="rowsAnalitico"
                    [totalRecords]="totalRegistrosAnalitico"
                    [carregando]="carregandoAnalitico"
                    [rotuloVoltar]="'Voltar às estatísticas'"
                    [colunaDetalhe]="obterColunaDetalheAnalitico()"
                    [colunaIdentificador]="'CNPJ'"
                    [colunaNome]="'RAZÃO SOCIAL'"
                    [voltarNoCard]="true"
                    [permitirVisualizacaoCard]="true"
                    (voltar)="voltarParaEstatisticas()"
                    (paginaAlterada)="onPageChangeAnalitico($event)"
                >
                    <section detalhamento-acoes class="analitico-filtros-card">
                        <div class="analitico-filtros-card-header">
                            <span class="analitico-filtros-card-icon"><i class="pi pi-filter"></i></span>
                            <h3 class="analitico-filtros-card-title">Filtros</h3>
                        </div>

                        <label class="analitico-filtro" for="estatisticas-prestador-grupo-analitico">
                            <span class="mapa-filtro-label">Indicador</span>
                            <select id="estatisticas-prestador-grupo-analitico" class="analitico-select" [ngModel]="grupoAnaliticoCodigo" (ngModelChange)="onGrupoAnaliticoChange($event)">
                                @for (opcao of obterOpcoesGrupoAnalitico(); track opcao.codigo) {
                                    <option [ngValue]="opcao.codigo">{{ obterDescricaoItem(opcao) }}</option>
                                }
                            </select>
                        </label>
                    </section>
                </app-detalhamento-pendencias>
            } @else {
                @let agrupador = obterAgrupadorSelecionado();

                @if (grupoSelecionadoSlug === 'servicos') {
                    <div class="subgrupos-navegacao">
                        <button type="button" class="subgrupo-item" [class.active]="subgrupoSelecionado === 'tudo'" (click)="subgrupoSelecionado = 'tudo'">Tudo</button>
                        <button type="button" class="subgrupo-item" [class.active]="subgrupoSelecionado === 'cnae'" (click)="subgrupoSelecionado = 'cnae'">CNAEs</button>
                        <button type="button" class="subgrupo-item" [class.active]="subgrupoSelecionado === 'servicos'" (click)="subgrupoSelecionado = 'servicos'">Serviços & Atividades</button>
                        <button type="button" class="subgrupo-item" [class.active]="subgrupoSelecionado === 'especialidades'" (click)="subgrupoSelecionado = 'especialidades'">Especialidades</button>
                        <button type="button" class="subgrupo-item" [class.active]="subgrupoSelecionado === 'recursos'" (click)="subgrupoSelecionado = 'recursos'">Recursos (RH/Materiais)</button>
                    </div>
                }

                @for (secao of obterSecoesEstatisticas(); track secao.titulo) {
                    <section class="estatistica-secao">
                        @if (secao.mostrarTitulo) {
                            <h3 class="subsecao-titulo">{{ secao.titulo }}</h3>
                        }
                        <div class="estatisticas-grid" [attr.aria-label]="secao.mostrarTitulo ? secao.titulo : 'Estatísticas de cadastro de prestador'">
                            @for (grupo of secao.grupos; track grupo.id) {
                                <div
                                    class="card-entrada card-entrada-1"
                                    [ngClass]="[grupo.classeGrupo, 'span-' + grupo.visualizacao]"
                                    [class.estatistica-card-linha-inteira]="grupo.linhaInteira"
                                    role="button"
                                    tabindex="0"
                                    [attr.aria-label]="'Maximizar ' + grupo.titulo"
                                    (click)="maximizarGrupo(grupo)"
                                    (keydown.enter)="maximizarGrupo(grupo)"
                                    (keydown.space)="$event.preventDefault(); maximizarGrupo(grupo)"
                                >
                                    <app-card-content [border]="false" [title]="grupo.titulo" [subtitle]="grupo.descricao" [icon]="agrupador.icon">
                                        <div card-header class="flex items-center gap-2" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                                            @if (possuiAnalitico(grupo)) {
                                                <p-button
                                                    icon="pi pi-table"
                                                    styleClass="botao-topo-acao"
                                                    [text]="true"
                                                    [rounded]="true"
                                                    title="Visualizar dados estatísticos"
                                                    ariaLabel="Visualizar dados estatísticos"
                                                    (onClick)="$event.stopPropagation(); selecionarEstatisticaAnalitica(grupo)"
                                                ></p-button>
                                            }
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="$event.stopPropagation(); maximizarGrupo(grupo)"
                                            ></p-button>
                                        </div>

                                        <div class="estatistica-total-bloco">
                                            @if (obterTotalGrupo(grupo) !== null) {
                                                <span class="estatistica-total-valor">{{ obterTotalGrupo(grupo) | number }}</span>
                                                <span class="estatistica-total-label">{{ grupo.rotuloTotal }}</span>
                                            } @else {
                                                <p-skeleton width="92px" height="30px" />
                                            }
                                        </div>

                                        <div class="estatistica-lista">
                                            @if (grupo.carregando) {
                                                @for (linha of [1, 2, 3, 4]; track linha) {
                                                    <div class="estatistica-linha">
                                                        <div class="estatistica-linha-texto">
                                                            <p-skeleton width="130px" height="16px" />
                                                            <p-skeleton width="80px" height="12px" />
                                                        </div>
                                                        <p-skeleton width="56px" height="20px" />
                                                    </div>
                                                }
                                            } @else if (grupo.itens?.length) {
                                                <div class="estatistica-grafico-container" [class.grafico-pizza]="grupo.visualizacao === 'rosca'">
                                                    <p-chart [type]="obterTipoGrafico(grupo)" [data]="obterDadosGrafico(grupo)" [options]="obterOpcoesGrafico(grupo)"></p-chart>
                                                </div>

                                                @if (grupo.visualizacao !== 'linha') {
                                                    @for (item of grupo.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                                                        <div class="estatistica-linha">
                                                            <div class="estatistica-linha-texto">
                                                                <span class="estatistica-item-descricao">{{ obterDescricaoItem(item) }}</span>
                                                                @if (obterComplementoItem(item)) {
                                                                    <span class="estatistica-item-complemento">{{ obterComplementoItem(item) }}</span>
                                                                }
                                                                <span class="estatistica-barra"><span [style.width]="obterLarguraBarra(grupo, item)"></span></span>
                                                            </div>
                                                            <span class="estatistica-item-total">{{ item.total ?? 0 | number }}</span>
                                                        </div>
                                                    }
                                                }
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>
                            }
                        </div>
                    </section>
                }
            }
        </ng-template>
    </app-painel-lateral>
</div>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Estatísticas do grupo em tela cheia."
    [(visible)]="exibirModalMaximizados"
    [header]="grupoMaximizado?.titulo ?? ''"
    [style]="{ width: '90vw', maxWidth: '560px' }"
    [breakpoints]="{ '640px': '95vw' }"
    [dismissableMask]="true"
    (onHide)="grupoMaximizado = null"
    styleClass="modal-estatistica-custom"
>
    @if (grupoMaximizado) {
        <div class="estatistica-card modal-card-wrapper" [ngClass]="grupoMaximizado.classeGrupo">
            <div class="estatistica-topo">
                <div class="estatistica-identidade">
                    <span class="estatistica-icone"><i [class]="obterAgrupadorSelecionado().icon"></i></span>
                    <p-tag [rounded]="true" class="grupo-badge">{{ grupoMaximizado.grupo }}</p-tag>
                </div>

                @if (possuiAnalitico(grupoMaximizado)) {
                    <div class="estatistica-acoes" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                        <p-button
                            icon="pi pi-table"
                            styleClass="botao-topo-acao"
                            [text]="true"
                            [rounded]="true"
                            title="Visualizar dados estatísticos"
                            ariaLabel="Visualizar dados estatísticos"
                            (onClick)="$event.stopPropagation(); selecionarEstatisticaAnalitica(grupoMaximizado)"
                        ></p-button>
                    </div>
                }
            </div>

            <div class="estatistica-total-bloco">
                @if (obterTotalGrupo(grupoMaximizado) !== null) {
                    <span class="estatistica-total-valor">{{ obterTotalGrupo(grupoMaximizado) | number }}</span>
                    <span class="estatistica-total-label">{{ grupoMaximizado.rotuloTotal }}</span>
                }
            </div>

            <p class="estatistica-descricao">{{ grupoMaximizado.descricao }}</p>

            <div class="modal-visualizacao-conteudo">
                @if (grupoMaximizado.itens?.length) {
                    <div class="modal-grafico-container" [class.modal-grafico-pizza]="grupoMaximizado.visualizacao === 'rosca'">
                        <p-chart [type]="obterTipoGrafico(grupoMaximizado)" [data]="obterDadosGrafico(grupoMaximizado)" [options]="obterOpcoesGrafico(grupoMaximizado, true)"></p-chart>
                    </div>

                    <div class="modal-lista-scroll">
                        @for (item of grupoMaximizado.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                            <div class="estatistica-linha">
                                <div class="estatistica-linha-texto">
                                    <span class="estatistica-item-descricao">{{ obterDescricaoItem(item) }}</span>
                                    @if (obterComplementoItem(item)) {
                                        <span class="estatistica-item-complemento">{{ obterComplementoItem(item) }}</span>
                                    }
                                    <span class="estatistica-barra"><span [style.width]="obterLarguraBarra(grupoMaximizado, item)"></span></span>
                                </div>
                                <span class="estatistica-item-total">{{ item.total ?? 0 | number }}</span>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="estatistica-sem-dados">Sem dados</div>
                }
            </div>
        </div>
    }
</p-dialog>
